<template>
    <div class="questionnaire-question-file">
        <Upload
            single-file
            @file-selected="upload"
        />
    </div>
</template>

<script lang="ts" setup>
import type {
    QuestionnaireAnswerInput,
    QuestionnaireQuestionFileFragment,
} from '@/graphql/api'

import Upload from '@/components/ui/Upload.vue'

const props = defineProps<{
    question: QuestionnaireQuestionFileFragment
    answer: QuestionnaireAnswerInput | undefined
    focus: boolean
}>()

const emit = defineEmits<{
    'update:answer': [answer: QuestionnaireAnswerInput | undefined]
}>()

const upload = (file: File | null) => {
    if (file) {
        emit('update:answer', {
            answer: { file: { file: file } },
            question: {
                referenceId: props.question.id,
                title: props.question.title,
            },
        })
    } else {
        emit('update:answer', {
            answer: { file: null },
            question: {
                referenceId: props.question.id,
                title: props.question.title,
            },
        })
    }
}
</script>

<style lang="scss" scoped>
.questionnaire-question-file {
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>
